const REACT_APP_API_END_POINT = process.env.REACT_APP_API_END_POINT;
const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const REACT_APP_PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
const REACT_APP_SITE_URL = process.env.REACT_APP_SITE_URL;
const REACT_APP_SIMULATION_3DOF_VERSION = process.env.REACT_APP_SIMULATION_3DOF_VERSION;
const REACT_APP_DIA_DIP_TAG_VERSION = process.env.REACT_APP_DIA_DIP_TAG_VERSION;

export { REACT_APP_API_END_POINT, REACT_APP_GOOGLE_CLIENT_ID, REACT_APP_PORTAL_URL, REACT_APP_SITE_URL, REACT_APP_SIMULATION_3DOF_VERSION, REACT_APP_DIA_DIP_TAG_VERSION };
